"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=({hoverColor:o})=>({padding:"8px",borderRadius:"100px",display:"flex","&:hover":{backgroundColor:o,cursor:"pointer"}});exports.getRootStyles=e;
